import { LiqaElement, NAME } from "@/wraps/web-component"

export { preload, type PreloadOptions, FEATURE, type Feature } from "@/preload"
export { Liqa, type LiqaConfig } from "@/wraps/factory"
export type {
  AnalyticsDetails,
  AnalyticsEventsMap,
  CaptureFormat,
  CaptureMetadata,
  CaptureTransformations,
  ErrorCodes,
  ImageCapture,
  LiqaAttributes,
  LiqaElement,
  LiqaError,
  LiqaEventMap,
} from "@/wraps/web-component"

/**
 * The library version.
 * @example
 * ```js
 * "6.0.0"
 * ```
 * @category Misc
 */
export const VERSION = import.meta.env.VERSION

/** Register web component and make it available as an HTML tag */
if (!customElements.get(NAME)) customElements.define(NAME, LiqaElement)
